<template>
	<div class="forgot-password-page">
		<div class="forgot-container">
			<div class="forgot-content">
				<h3 class="forgot-title">找回密码</h3>
				<div class="forgot-form">
					<div class="input-group">
						<input type="text" placeholder="请输入手机号" v-model="form.phone">
					</div>
					<div class="input-group">
						<input type="text" placeholder="请输入验证码" v-model="form.code">
						<span class="get-verify-code" @click="sendVerifyCode"
							:style="{ cursor: isSending ? 'not-allowed' : 'pointer', color: isSending ? '#999' : '#FE8E04' }">{{ codeText }}</span>
					</div>
					<div class="input-group">
						<input :type="showPassword ? 'text' : 'password'" placeholder="请设置6-12位新密码"
							v-model="form.password">
						<span class="toggle-pwd" @click="showPassword = !showPassword">
							<svg v-if="!showPassword" viewBox="0 0 24 24" width="16" height="16" stroke="currentColor"
								stroke-width="2" fill="none">
								<path
									d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
								</path>
								<line x1="1" y1="1" x2="23" y2="23"></line>
							</svg>
							<svg v-else viewBox="0 0 24 24" width="16" height="16" stroke="currentColor"
								stroke-width="2" fill="none">
								<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
								<circle cx="12" cy="12" r="3"></circle>
							</svg>
						</span>
					</div>
					<div class="input-group">
						<input :type="showConfirmPassword ? 'text' : 'password'" placeholder="请再次确认新密码"
							v-model="form.confirmPassword">
						<span class="toggle-pwd" @click="showConfirmPassword = !showConfirmPassword">
							<svg v-if="!showConfirmPassword" viewBox="0 0 24 24" width="16" height="16"
								stroke="currentColor" stroke-width="2" fill="none">
								<path
									d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24">
								</path>
								<line x1="1" y1="1" x2="23" y2="23"></line>
							</svg>
							<svg v-else viewBox="0 0 24 24" width="16" height="16" stroke="currentColor"
								stroke-width="2" fill="none">
								<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
								<circle cx="12" cy="12" r="3"></circle>
							</svg>
						</span>
					</div>

					<button class="confirm-btn" @click="handleSubmit">确认重置</button>

					<div class="go-login">
						<span @click="goToLogin">返回登录</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		sendCode,
		resetPwd
	} from '@/api/user'
	import { ElMessage } from 'element-plus'
	import 'element-plus/es/components/message/style/css'

	export default {
		name: 'ForgotPassword',
		data() {
			return {
				form: {
					phone: '',
					code: '',
					password: '',
					confirmPassword: ''
				},
				showPassword: false,
				showConfirmPassword: false,
				codeText: '获取验证码',
				isSending: false,
				timer: null
			}
		},
		methods: {
			goToLogin() {
				this.$router.push('/');
			},
			async handleSubmit() {
				const {
					phone,
					code,
					password,
					confirmPassword
				} = this.form;

				if (!phone) {
					ElMessage.warning('请输入手机号');
					return;
				}
				if (!/^1[3-9]\d{9}$/.test(phone)) {
					ElMessage.warning('请输入正确的手机号');
					return;
				}
				if (!code) {
					ElMessage.warning('请输入验证码');
					return;
				}
				if (!password) {
					ElMessage.warning('请输入新密码');
					return;
				}
				if (password.length < 6 || password.length > 12) {
					ElMessage.warning('密码长度请在6-12位之间');
					return;
				}
				if (password !== confirmPassword) {
					ElMessage.warning('两次输入的密码不一致');
					return;
				}

				try {
					await resetPwd({
						phone,
						password,
						code
					});
					ElMessage.success('密码重置成功，请重新登录');
					this.goToLogin();
				} catch (error) {
					ElMessage.error(error.message || '重置失败');
				}
			},
			async sendVerifyCode() {
				if (this.isSending) return;

				const phone = this.form.phone;
				if (!phone) {
					ElMessage.warning('请输入手机号');
					return;
				}
				if (!/^1[3-9]\d{9}$/.test(phone)) {
					ElMessage.warning('请输入正确的手机号');
					return;
				}

				this.isSending = true;
				try {
					// 假设 type 3 是找回密码，具体看后端定义，这里暂时复用逻辑
					await sendCode({
						phone: phone,
						type: 2 // 如果后端找回密码也是用2或者其他，请根据接口调整，这里假设通用验证码流程
					});

					// Start countdown
					let count = 60;
					this.codeText = `${count}s`;
					this.timer = setInterval(() => {
						count--;
						if (count > 0) {
							this.codeText = `${count}s`;
						} else {
							this.stopTimer();
						}
					}, 1000);

				} catch (error) {
					this.isSending = false;
					ElMessage.error(error.message || '发送验证码失败');
				}
			},
			stopTimer() {
				if (this.timer) {
					clearInterval(this.timer);
					this.timer = null;
				}
				this.isSending = false;
				this.codeText = '获取验证码';
			}
		},
		beforeUnmount() {
			this.stopTimer();
		}
	}
</script>

<style scoped>
	.forgot-password-page {
		width: 100%;
		min-height: calc(100vh - 60px);
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #111;
	}

	.forgot-container {
		width: 800px;
		background-color: #1a1a1a;
		color: #fff;
		border-radius: 4px;
		padding: 40px 0;
	}

	.forgot-content {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.forgot-title {
		font-size: 24px;
		font-weight: bold;
		color: #fff;
		margin-bottom: 40px;
	}

	.forgot-form {
		width: 400px;
		display: flex;
		flex-direction: column;
		gap: 20px;
	}

	.input-group {
		position: relative;
		border-bottom: 1px solid #333;
	}

	.input-group input {
		width: 100%;
		background: transparent;
		border: none;
		padding: 15px 0;
		color: #fff;
		font-size: 14px;
		outline: none;
	}

	.input-group input::placeholder {
		color: #666;
	}

	.get-verify-code {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		color: #FE8E04;
		cursor: pointer;
		font-size: 14px;
		user-select: none;
	}

	.toggle-pwd {
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		cursor: pointer;
		width: 20px;
		height: 20px;
		color: #999;
	}

	.confirm-btn {
		width: 100%;
		padding: 12px;
		background-color: #FE8E04;
		color: #fff;
		border: none;
		border-radius: 25px;
		font-size: 16px;
		margin-top: 20px;
		cursor: pointer;
	}

	.confirm-btn:hover {
		background-color: #e68a00;
	}

	.go-login {
		text-align: center;
		margin-top: 20px;
		font-size: 14px;
		color: #FE8E04;
		cursor: pointer;
	}

	.go-login span:hover {
		text-decoration: underline;
	}
</style>